const styles = (theme) => ({
  root: {
    cursor: "none !important",
    paddingTop: "190px",
    marginTop: "-1px",
    display: "flex",
    position: "relative",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    maxWidth: "1700px",
    margin: "auto",
    paddingLeft: "10rem",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1400)]: {
      paddingLeft: "6rem",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1300)]: {
      paddingLeft: "2rem",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1230)]: {
      paddingLeft: "0",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
      paddingTop: 0,
    },
  },
  h1: {
    cursor: "none !important",
    color: "black",
    fontFamily: "Montserrat",
    fontWeight: "700",
    fontSize: "60px",
    lineHeight: "70px",
    display: "table",
    letterSpaCing: "0.01em",
    margin: 0,
    maxWidth: "18ch",
    marginBottom: "40px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1230)]: {
      paddingLeft: "1rem",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
      fontSize: "32px",
      lineHeight: "38.5px",
      maxWidth: "100%",
      marginBottom: "20px",
    },
  },
  p: {
    cursor: "none !important",
    color: "black",
    fontFamily: "Aktiv Grotesk",
    display: "table",
    fontWeight: "400",
    fontSize: "1rem",
    margin: 0,
    lineHeight: "22.5px",
    letterSpacing: "0.01em",
    maxWidth: "74ch",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 1230)]: {
      padding: "0 1rem",
    },
  },
});

export default styles;